import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { AlertService } from 'ngx-alerts';  
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.css']
})
export class PurchaseOrderComponent implements OnInit {

  constructor(private  commonService: CommonService, private spinner: NgxSpinnerService, private alertService: AlertService, private session: SessionStorageService, private activatedRoute: ActivatedRoute, private routes: Router) { }

  public address = this.activatedRoute.snapshot.queryParams["address"];
  public btcqty = this.activatedRoute.snapshot.queryParams["value"];
  
  ngOnInit() {   
    if(this.session.retrieve('token')){
      this.commonService.tokenValidity().then((res: any) => {
        this.spinner.hide();
        }).catch((err: any) => {     
            this.alertService.danger(err.message);
            this.spinner.hide();
            this.routes.navigate(['/login']);
      });
    }else{      
      this.routes.navigate(['/login']);
    }
  }
}
